/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Enabled_ToastInputs */



/**
* | output |
* | --- |
* | "Live captioning enabled." |
*
* @param {Live_Caption_Enabled_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_enabled_toast = /** @type {((inputs?: Live_Caption_Enabled_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Enabled_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titrage en direct activé.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Live-Untertitelung aktiviert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli in tempo reale attivati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включена функция субтитров в реальном времени.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos en directo activados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已启用实时字幕。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リアルタイム字幕が有効になっています。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग चालू है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas ao vivo ativadas.")
	return /** @type {LocalizedString} */ ("Live captioning enabled.")
});